import { Box, Button, Chip, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { useNavigate } from "react-router-dom";
import DynamicPageLayout from "../common/DynamicPageLayout";
import { useInventoryDetails } from "./useInventoryDetails";
import { useSelectInventoryQuery } from "../../store/services/componentsQuery";

const InventoryDetails: React.FunctionComponent<any> = () => {
  const navigate = useNavigate();
  const {
    // inventorySampleInfoContentJson,
    // inventorySampleInfo2ContentJson,
    // inventoryPatientInfoContentJson,
    // inventoryPatientInfo2ContentJson,
    // inventoryPatientInfo3ContentJson,
    // inventoryParentInfoContentJson,
    // inventoryTestContentJson,
    totalData,
  } = useInventoryDetails();

  const { data: selectInventoryData } = useSelectInventoryQuery({});

  const [fields, setFields] = useState<any>([]);

  useEffect(() => {
    if (selectInventoryData) {
      const temp = selectInventoryData?.map((item: any) => item.content);
      temp?.forEach((item: any) => {
        const a: any = {};
        a.title = item[0]?.title;
        a.content = item.map((item: any) => {
          if (item.label == "Name") {
            return { ...item, fieldName: "name", value: "John Doe" };
          } else {
            return { ...item, value: totalData[item.fieldName] || "" };
          }
        });

        setFields((fields: any) => [...fields, a]);
      });
    }
  }, [selectInventoryData]);

  return (
    <>
      <Box className="backBtnWrap">
        <Button
          startIcon={<ArrowBackIosNewRoundedIcon />}
          size="small"
          onClick={() => navigate("/inventory")}
        >
          Back
        </Button>
      </Box>
      <Grid container spacing={2} mb={2}>
        <Grid item xs>
          <Typography variant="h4" className="dFlex alignItemsCenter">
            S101&nbsp;{" "}
            <Chip label="IND 145958" variant="outlined" color="info" />
          </Typography>
        </Grid>
        <Grid item justifyContent="flex-end">
          &nbsp;
        </Grid>
      </Grid>

      <DynamicPageLayout pageContentJson={fields} data={{}} />

      {/* <Card>
        <Grid container spacing={0}>
          <Grid item md={12}>
            <Typography variant="h5" sx={{ ml: 2, mt: 1.5 }}>
              Sample Info
            </Typography>
          </Grid>
          <Grid item md={9}>
            <DynamicPageLayout
              pageContentJson={inventorySampleInfoContentJson}
              data={{}}
            />
          </Grid>
          <Grid item md={3}>
            <DynamicPageLayout
              pageContentJson={inventorySampleInfo2ContentJson}
              data={{}}
            />
          </Grid>
        </Grid>
      </Card>

      <Card>
        <Grid container spacing={0}>
          <Grid item md={12}>
            <Typography variant="h5" sx={{ ml: 2, mt: 1.5 }}>
              Patient Info
            </Typography>
          </Grid>
          <Grid item md={4}>
            <DynamicPageLayout
              pageContentJson={inventoryPatientInfoContentJson}
              data={{}}
            />
          </Grid>
          <Grid item md={4}>
            <DynamicPageLayout
              pageContentJson={inventoryPatientInfo2ContentJson}
              data={{}}
            />
          </Grid>
          <Grid item md={4}>
            <DynamicPageLayout
              pageContentJson={inventoryPatientInfo3ContentJson}
              data={{}}
            />
          </Grid>
        </Grid>
      </Card>

      <DynamicPageLayout
        pageContentJson={inventoryParentInfoContentJson}
        data={{}}
      />

      <DynamicPageLayout pageContentJson={inventoryTestContentJson} data={{}} /> */}
    </>
  );
};

export default InventoryDetails;
